export default __webpack_public_path__ + "static/media/CloseIcon.26d505ef.svg";